import { DEFAULT_AFTER_LOGIN, safeNextPath } from './safeNext';

/**
 * T2816 — dvostopenjska prijava: skupne konstante odjemalca.
 *
 * Sysadmin brez vklopljene 2FA (`auth/me/` → `two_factor.setup_required`) gre
 * po prijavi in ob vsakem obisku Sysadmin najprej sem; zaledje mu do vklopa
 * API sysadmina zavrne s 403 `TWO_FACTOR_SETUP_REQUIRED`.
 */
export const TWO_FACTOR_SETUP_PATH = '/settings?tab=security&setup2fa=1';

/**
 * T3000 — nastavitev 2FA, ki prvotni cilj nese naprej v svojem `next`.
 *
 * Sysadmin brez 2FA, ki pride z globoke povezave (npr. pošta o kandidatu na
 * čakalni listi → `/sysadmin/users?tab=waitlist`), mora najprej vklopiti 2FA.
 * Brez tega bi se cilj na vmesni poti izgubil. `next` gre skozi `safeNextPath`;
 * privzeti cilj in sama nastavitev 2FA se ne zapišeta.
 */
export function twoFactorSetupPath(next?: string | null): string {
  const safe = safeNextPath(next);
  if (safe !== next || safe === DEFAULT_AFTER_LOGIN || safe.startsWith(TWO_FACTOR_SETUP_PATH)) {
    return TWO_FACTOR_SETUP_PATH;
  }
  return `${TWO_FACTOR_SETUP_PATH}&next=${encodeURIComponent(safe)}`;
}

/**
 * T2959 — kam po prijavi: obvezna nastavitev 2FA ima prednost pred `next`.
 *
 * Po prijavi tečeta hkrati obrazec (`LoginPage.finishLogin`) in preusmeritev
 * poti `/login` (`LoginRoute`, T2519) — `login(user)` stanje seje zamenja
 * sinhrono. Če cilja ne izračunata enako, zmaga tisti, ki teče zadnji: pot je
 * sysadmina brez 2FA z `replace` vrnila na `/dashboard`. Zato je pravilo eno.
 *
 * T3000: `next` preživi tudi obvezno nastavitev — gre v njen `next`.
 */
export function afterLoginPath(
  user: { two_factor?: { setup_required: boolean } } | null | undefined,
  nextPath: string,
): string {
  return user?.two_factor?.setup_required ? twoFactorSetupPath(nextPath) : nextPath;
}
